<template>
  <div class="index">
    <Banner></Banner>
    <Quiz v-on:finish="finish" :selected="toothbrush" :toothbrushColor="toothbrushColor"></Quiz>
    <transition name="fade" mode="out-in">
      <Toothbrushes v-on:color-choose="choosed" v-if="finished" v-bind:key="finished" :selected="toothbrush" :redirect="false"></Toothbrushes>
    </transition>
  </div>
</template>

<script>
import Banner from './Banner.vue'
import Quiz from './Quiz.vue'
import Toothbrushes from '../index/Toothbrushes.vue'

export default {
  data () {
    return {
      selected: false,
      finished: false,
      toothbrush: false,
      toothbrushColor: false
    }
  },
  components: {
    Banner,
    Quiz,
    Toothbrushes
  },
  methods: {
    finish: function (e) {
      this.toothbrushColor = e.key
      this.finished = true
      this.toothbrush = e
    },
    choosed: function (e) {
      this.finished = true
      this.toothbrush = e
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/quiz/Index.vue